import {
  MAX_YEARS,
  MIN_YEARS,
} from '~addListing/pages/PriceStep/utils/constants';

const clampYears = (years: number) =>
  Math.min(Math.max(years, MIN_YEARS), MAX_YEARS);

export default clampYears;
